module.exports = __webpack_public_path__ + "static/GaleriesLafayetteBackground-22807a09a09c38b058fb8562160cc4d7.jpg";